"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _documentListing = _interopRequireDefault(require("./document-listing"));

var _featureDocumentListing = _interopRequireDefault(require("./feature-document-listing"));

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /** setting for bottom padding amount */
  bottomUnitPadding: _propTypes.number,

  /** Array of documents to display */
  documentsList: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,

  /** Default handler for download item onClick */
  downloadAction: _propTypes.func,

  /** Array of documents to display */
  featuredDocumentsList: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,

  /** heading tag */
  headingTag: _propTypes.string,

  /** Number of maximum items to show */
  maxItemsToShow: _propTypes.number,

  /** Handler to be called when the show more button is clicked */
  moreButtonOnClick: _propTypes.func,

  /** Theme config object */
  theme: _utils.themePropType,

  /** Title of type string */
  title: _propTypes.string,

  /** setting for top padding amount * */
  topUnitPadding: _propTypes.number
};

var DocumentsListModule = function DocumentsListModule(_ref) {
  var bottomUnitPadding = _ref.bottomUnitPadding,
      downloadAction = _ref.downloadAction,
      headingTag = _ref.headingTag,
      maxItemsToShow = _ref.maxItemsToShow,
      moreButtonOnClick = _ref.moreButtonOnClick,
      _ref$documentsList = _ref.documentsList,
      documentsList = _ref$documentsList === void 0 ? [] : _ref$documentsList,
      _ref$featuredDocument = _ref.featuredDocumentsList,
      featuredDocumentsList = _ref$featuredDocument === void 0 ? [] : _ref$featuredDocument,
      theme = _ref.theme,
      title = _ref.title,
      topUnitPadding = _ref.topUnitPadding;
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Wrapper, null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    pb: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return bottomUnitPadding * padding;
    }),
    pt: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return topUnitPadding * padding;
    }),
    width: 1
  }, featuredDocumentsList.length !== 0 && /*#__PURE__*/_react["default"].createElement(_featureDocumentListing["default"], {
    documentsList: featuredDocumentsList
  }), documentsList.length !== 0 && /*#__PURE__*/_react["default"].createElement(_documentListing["default"], {
    documentsList: documentsList,
    downloadAction: downloadAction,
    headingTag: headingTag,
    maxItemsToShow: maxItemsToShow,
    moreButtonOnClick: moreButtonOnClick,
    title: title
  })));
};

DocumentsListModule.propTypes = propTypes;
DocumentsListModule.displayName = "Modules.DocumentsListModule";

var _default = (0, _styledComponents.withTheme)(DocumentsListModule);

exports["default"] = _default;